import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Question } from '../../../../models/question';
import { QuestionAnswer } from '../../../../models/question-answer';

@Component({
  selector: 'lib-configure-conditional-logic-modal',
  templateUrl: './configure-conditional-logic-modal.component.html',
  styleUrls: ['./configure-conditional-logic-modal.component.scss']
})
export class ConfigureConditionalLogicModalComponent implements OnInit {
  public submitted = false;
  public question: Question;
  public questions: Array<Question> = [];
  public questionAnswer = QuestionAnswer;

  get isValid(): boolean {
    return this.question.conditionalDependsUid != null && this.question.conditionalOn != null;
  }

  constructor(public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig) {
    this.question = this.dynamicDialogConfig?.data?.question;
    this.questions = this.dynamicDialogConfig?.data?.questions;
  }

  ngOnInit(): void {
  }

  save(): void {
    this.submitted = true;

    // validation
    if (!this.isValid) {
      return;
    }

    this.question.conditionalDepends = this.questions.find(q => q.uid === this.question.conditionalDependsUid);
    this.dynamicDialogRef.close(this.question);
  }

  cancel(): void {
    this.dynamicDialogRef.destroy();
  }
}
